import { getTutorSchedule, type CalendarFor } from '@/app/actions/bookings';
import { callAction } from '@/lib/call-action';

type ScheduleResult = Awaited<ReturnType<typeof getTutorSchedule>>;

const inFlight = new Map<string, Promise<ScheduleResult>>();

export function requestSchedule(
  tutorUsername: string,
  calendar: CalendarFor,
  timezone: string,
  excludedClassId?: string
): Promise<ScheduleResult> {
  const ref = 'bundleId' in calendar ? calendar.bundleId : calendar.courseId;
  const key = `${tutorUsername}|${ref}|${timezone}|${excludedClassId ?? ''}`;
  const pending = inFlight.get(key);
  if (pending) return pending;

  const request = callAction(() =>
    getTutorSchedule(tutorUsername, calendar, 30, excludedClassId, timezone)
  ).finally(() => inFlight.delete(key));
  inFlight.set(key, request);
  return request;
}
